import { InstanceInfo } from "app/types-shared";
import { ApplicationState } from "app/types-store";
import { useSelector } from "react-redux";

const getTenant = (instanceInfo: InstanceInfo): string | undefined => {
  return instanceInfo ? `${instanceInfo.envType}${instanceInfo.tenantId}` : undefined;
};

const useInstanceInfo = () =>
  useSelector(
    (state: ApplicationState) => state?.app?.instanceInfo
  );

const useAiChatAssistantState = () =>
  useSelector(
    (state: ApplicationState) => state?.aiChatAssistant
  );

export const useAiChatAssistantAccessInfo = () =>
  useSelector(
    (state: ApplicationState) => state?.app?.aiChatAssistantAccessInfo
  );

export function useAiChatAssistantSelectors() {
  const {chatAssistant = false, fiveWhys = false, caseDraftCreation = false} = useAiChatAssistantAccessInfo() ?? {};
  const instanceInfo = useInstanceInfo();
  const aiChatAssistantState = useAiChatAssistantState();
  const tenant = getTenant(instanceInfo);

  return {
    enableChatAssistant: chatAssistant ?? false,
    enableFiveWhys: fiveWhys ?? false,
    caseDraftCreation,
    tenant,
    running: aiChatAssistantState?.running ?? false,
    createDraft: aiChatAssistantState?.createDraft ?? false
  };
}
